import { Attachment } from '../../../TestResults.types';
import { getFileName, getFileType, isMediaAttachment, orderAttachmentsByType } from './AttachmentsTab.utils';
import MediaAttachment from './components/MediaAttachment';
import NonMediaAttachment from './components/NonMediaAttachment';

const AttachmentsTabContent = ({ attachments }: { attachments: Attachment[] }) => {
  return (
    <>
      {orderAttachmentsByType(attachments).map((attachment) => {
        const fileName = getFileName(attachment.url);
        const type = getFileType(fileName);

        return isMediaAttachment(type) ? (
          <MediaAttachment key={attachment.url} {...attachment} type={type} fileName={fileName} />
        ) : (
          <NonMediaAttachment key={attachment.url} {...attachment} type={type} fileName={fileName} />
        );
      })}
    </>
  );
};

export default AttachmentsTabContent;
